import React from "react";

const hasHtmlTags = (value = "") => /<\/?[a-z][\s\S]*>/i.test(String(value));

const isSafeUrl = (value = "") => /^(https?:\/\/|\/)/i.test(String(value).trim());

const parseLinkValue = (raw = "") => {
  const [labelPart, urlPart] = String(raw).split("|").map((part) => part.trim());
  const url = urlPart || labelPart || "";
  const label = urlPart ? labelPart || url : url;
  return {
    label,
    url: isSafeUrl(url) ? url : "",
  };
};

const flushList = (blocks, listItems) => {
  if (!listItems.length) return;
  blocks.push({ type: "list", items: [...listItems] });
  listItems.length = 0;
};

export const parseBlogContent = (value = "") => {
  const source = String(value || "").trim();
  if (!source) return [];

  if (hasHtmlTags(source)) {
    return [{ type: "html", html: source }];
  }

  const lines = source.split(/\r?\n/);
  const blocks = [];
  const listItems = [];

  lines.forEach((line) => {
    const trimmed = line.trim();

    if (!trimmed) {
      flushList(blocks, listItems);
      return;
    }

    const headingMatch = trimmed.match(/^(title|heading|h2|h3)\s*:\s*(.+)$/i);
    if (headingMatch) {
      flushList(blocks, listItems);
      blocks.push({
        type: headingMatch[1].toLowerCase() === "h3" ? "h3" : "h2",
        text: headingMatch[2].trim(),
      });
      return;
    }

    const quoteMatch = trimmed.match(/^quote\s*:\s*(.+)$/i);
    if (quoteMatch) {
      flushList(blocks, listItems);
      blocks.push({ type: "quote", text: quoteMatch[1].trim() });
      return;
    }

    const linkMatch = trimmed.match(/^link\s*:\s*(.+)$/i);
    if (linkMatch) {
      flushList(blocks, listItems);
      blocks.push({ type: "link", ...parseLinkValue(linkMatch[1]) });
      return;
    }

    const listMatch = trimmed.match(/^[-*]\s+(.+)$/);
    if (listMatch) {
      listItems.push(listMatch[1].trim());
      return;
    }

    const paragraphMatch = trimmed.match(/^text\s*:\s*(.+)$/i);
    if (paragraphMatch) {
      flushList(blocks, listItems);
      blocks.push({ type: "paragraph", text: paragraphMatch[1].trim() });
      return;
    }

    flushList(blocks, listItems);
    blocks.push({ type: "paragraph", text: trimmed });
  });

  flushList(blocks, listItems);
  return blocks;
};

export const renderBlogContent = (value = "") => {
  const blocks = parseBlogContent(value);

  return blocks.map((block, index) => {
    if (block.type === "html") {
      return (
        <div
          key={`blog-block-${index}`}
          className="qtech-blog-richtext-block"
          dangerouslySetInnerHTML={{ __html: block.html }}
        />
      );
    }

    if (block.type === "h2") {
      return (
        <h4 key={`blog-block-${index}`} className="title-2 mt-35">
          {block.text}
        </h4>
      );
    }

    if (block.type === "h3") {
      return (
        <h5 key={`blog-block-${index}`} className="mt-30">
          {block.text}
        </h5>
      );
    }

    if (block.type === "quote") {
      return (
        <blockquote key={`blog-block-${index}`} className="mt-30">
          {block.text}
        </blockquote>
      );
    }

    if (block.type === "list") {
      return (
        <ul key={`blog-block-${index}`} className="ltn__list-item-half clearfix mt-25">
          {block.items.map((item, itemIndex) => (
            <li key={`blog-list-item-${index}-${itemIndex}`}>{item}</li>
          ))}
        </ul>
      );
    }

    if (block.type === "link") {
      if (!block.url) return null;
      return (
        <p key={`blog-block-${index}`} className="mt-20">
          <a href={block.url} target="_blank" rel="noreferrer">
            {block.label}
          </a>
        </p>
      );
    }

    return (
      <p key={`blog-block-${index}`} className="mt-20">
        {block.text}
      </p>
    );
  });
};
